import { getTableColumns } from '../Table/utils';
import { TabStatus, Tab } from './types';

function getPurchasesTableColumns() {
  return getTableColumns([
    {
      accessor: 'summary',
      header: 'Description',
      wide: true,
      type: 'transaction-summary',
    },
    { accessor: 'purchase_date', header: 'Date', type: 'date' },
    { accessor: 'price', header: 'Amount', type: 'amount' },
  ]);
}

/**
 * Predictate to filter tabs by given status
 * @param {TabStatus} status - The status to filter
 * @return Tab[] matching the status
 **/
const byTabStatus =
  (...status: TabStatus[]) =>
  (tab: Tab) =>
    status.includes(tab.status);

export { getPurchasesTableColumns, byTabStatus };
